import type {
  AdminBattleBet,
  AdminBattleBetSummary,
} from "../../../types/api.generated";

export type { AdminBattleBet, AdminBattleBetSummary };

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("tokenUser");
  return { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
};

const getBaseUrl = () => process.env.REACT_APP_BACKEND_URL || "";

const parseJsonResponse = async (response: Response) => {
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(text || `Request failed with status ${response.status}`);
  }

  try {
    return await response.json();
  } catch (_) {
    return { ok: true };
  }
};

export const getAdminBattleBets = async (battleId: string): Promise<AdminBattleBet[]> => {
  const base = getBaseUrl();
  const response = await fetch(`${base}/admin/battles/${battleId}/bets`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  return parseJsonResponse(response);
};

export const getAdminBattleBetSummary = async (battleId: string): Promise<AdminBattleBetSummary> => {
  const base = getBaseUrl();
  const response = await fetch(`${base}/admin/battles/${battleId}/bets/summary`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  return parseJsonResponse(response);
};

export const payoutAdminBet = async (betId: string): Promise<any> => {
  const base = getBaseUrl();
  const response = await fetch(`${base}/admin/bets/${betId}/payouts`, {
    method: "POST",
    headers: getAuthHeaders(),
  });
  return parseJsonResponse(response);
};

export const payoutAdminBets = async (battleId: string, betIds: string[]): Promise<any> => {
  const base = getBaseUrl();
  const response = await fetch(`${base}/admin/bets/payouts`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ battleId, betIds }),
  });
  return parseJsonResponse(response);
};

export const refundAdminBet = async (betId: string): Promise<any> => {
  const base = getBaseUrl();
  const response = await fetch(`${base}/admin/bets/${betId}/refunds`, {
    method: "POST",
    headers: getAuthHeaders(),
  });
  return parseJsonResponse(response);
};

export const refundAdminBets = async (battleId: string, betIds: string[]): Promise<any> => {
  const base = getBaseUrl();
  const response = await fetch(`${base}/admin/bets/refunds`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ battleId, betIds }),
  });
  return parseJsonResponse(response);
};
